(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFaqAccordion = (scope = document) => {
      const accordions = scope.querySelectorAll?.('[data-faq-accordion]') || [];

      accordions.forEach((accordion) => {
        if (accordion.dataset.faqInitialized === 'true') return;

        accordion.dataset.faqInitialized = 'true';

        if (accordion.dataset.singleOpen !== 'true') return;

        const items = accordion.querySelectorAll('.faq-accordion__item');

        items.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;

            items.forEach((otherItem) => {
              if (otherItem !== item) {
                otherItem.removeAttribute('open');
              }
            });
          });
        });
      });
    };

    const init = () => {
      initializeFaqAccordion(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeFaqAccordion(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
